const parser = new DOMParser();

export const getTextContentFromHTML = (str: string): string =>
  parser.parseFromString(str, 'text/html').body.textContent || '';
